import { render } from "./CocktailsCarousel.vue?vue&type=template&id=166df234"
import script from "./CocktailsCarousel.vue?vue&type=script&lang=js"
export * from "./CocktailsCarousel.vue?vue&type=script&lang=js"

import "./CocktailsCarousel.vue?vue&type=style&index=0&id=166df234&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__